module.exports = __webpack_public_path__ + "assets/img/041905.903cf340.png";